import React, {Component} from 'react';
import {Field, FieldArray} from 'redux-form';
import RenderField from './RenderField';
import TextWithLine from './TextWithLine';
import AttributeOptions from './AttributeOptions';
import IncomeInformationForm from './IncomeInformationForm';

class SelfEmploymentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show_leasing_value_field: false

        }
        this.checkLeaseValue = this.checkLeaseValue.bind(this);
        this.renderIncomeInformation = this.renderIncomeInformation.bind(this);

    }

    checkLeaseValue(value){
        if (value === 1){
            this.setState({show_leasing_value_field: true});
        } else{
            this.setState({show_leasing_value_field: false});
            this.props.deleteReduxFormField('leasing_value');
        }
    }

    renderIncomeInformation({fields}){
        return (<div>
                    {fields.map((member, index, fields) => {
                       return (<IncomeInformationForm member={member} selfEmploymentType={this.props.selfEmploymentType} key={index}/>)
                    })}
                </div>);
    }


    render(){
        const monotributo_categories = [{id:0 , name:'A'},{id:1 , name:'B'},{id:2 , name:'C'},{id:3 , name:'D'},{id:4 , name:'E'},{id:5 , name:'F'},{id:6 , name:'G'},{id:7 , name:'H'},{id:8 , name:'I'},{id:9 , name:'J'},{id:10 , name:'K'}]
        const leasing_types = [{id:0 , name:'Alquila'},{id:1 , name:'Propietario'}]

        const leasing_value_field = (<div className="col-sm-12 col-md-4 col-lg-4">
                                        <Field className="form-control" name={'leasing_value'} autoComplete="off" component={RenderField} type="currency" label="Valor Alquiler" />
                                    </div>);

        const monotributo_category_field = (<div className="col-sm-12 col-md-4 col-lg-4">
                                            <AttributeOptions name="monotributo_category" defaultValue="Categoría" label="Categoría" attributeName='monotributo_category' attributeOptions={monotributo_categories}/>
                                    </div>);

        const monthly_costs_field = (<div className="col-sm-12 col-md-12 col-lg-4">
                                        <Field className="form-control" name={'monthly_costs'} autoComplete="off" component={RenderField} type="currency" label="Costos mensuales aprox." />
                                     </div>);

        const number_of_employees_field = (<div className="col-sm-12 col-md-12 col-lg-4">
                                                <Field className="form-control" name={'number_of_employees'} autoComplete="off" component={RenderField} type="number" label="Cantidad de Personal" />
                                           </div>);

        const leasing_type_field = (<div className="col-sm-12 col-md-12 col-lg-4">
                                        <AttributeOptions name="leasing_type" defaultValue="Locación de Trabajo" label="Locación de Trabajo" attributeName='leasing_types' attributeOptions={leasing_types} onChange={this.checkLeaseValue}/>
                                    </div>);

        const monotributo_fields =(<div>
                                       <div className='row'>
                                            {monotributo_category_field} 
                                            {monthly_costs_field}
                                            {number_of_employees_field}
                                       </div>
                                       <div className='row'>
                                            {leasing_type_field}
                                            {this.state.show_leasing_value_field && leasing_value_field}
                                       </div>
                                   </div>);

        const resp_inscripto_fields = (<div>
                                           <div className='row'>
                                                {monthly_costs_field}
                                                {number_of_employees_field}
                                                {leasing_type_field}
                                           </div>
                                           <div className='row'>
                                                {this.state.show_leasing_value_field && leasing_value_field}
                                           </div>
                                       </div>);

        return (<div >
                    <div className='row'> 
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <TextWithLine value={'Ingresos ' + this.props.selfEmploymentType}/>
                        </div>
                    </div>
                    {((this.props.selfEmploymentType === 'Monotributista') && monotributo_fields) || resp_inscripto_fields}
                    <FieldArray name="self_employment_incomes" component={this.renderIncomeInformation}/>
                </div>
                );
    }   
}
        


export default SelfEmploymentForm;



/** WEBPACK FOOTER **
 ** ./src/components/SelfEmploymentForm.js
 **/